/**
 * @param {Record<string, string> | string[] | null | undefined} data
 * @returns {{ value: number, label: string }[]}
 */
export function getDropdownOptions(data) {
  return (data && Object.entries(data).map(([value, label]) => ({ value: Number(value), label }))) || [];
}
